import { api } from './client';

// Phase 2: per-username override of which order (OF/OT) wins the open-geo listing dedup
// (model_active_source). source === null means no override — the listing defaults to OF.
export interface AdminActiveSourceView {
  username: string;
  source: 'OF' | 'OT' | null;
}

export const getActiveSource = async (username: string): Promise<AdminActiveSourceView> => {
  const { data } = await api.get<AdminActiveSourceView>(`/admin/active-source/${encodeURIComponent(username)}`);
  return data;
};

export const setActiveSource = async (username: string, source: 'OF' | 'OT'): Promise<AdminActiveSourceView> => {
  const { data } = await api.put<AdminActiveSourceView>(`/admin/active-source/${encodeURIComponent(username)}`, { source });
  return data;
};

export const clearActiveSource = async (username: string): Promise<void> => {
  await api.delete(`/admin/active-source/${encodeURIComponent(username)}`);
};

// Usernames with BOTH a live OF and a live OT PPC order — the CPC comparison table.
export interface AdminOfOtCompareRow {
  username: string;
  ofId: number;
  ofCpc: number | null;
  otId: number;
  otCpc: number | null;
  activeSource: 'OF' | 'OT' | null;
}

export const getOfOtCompare = async (): Promise<AdminOfOtCompareRow[]> => {
  const { data } = await api.get<AdminOfOtCompareRow[]>('/admin/active-source/compare');
  return data;
};
